const { VITE_USER_NODE_ENV } = import.meta.env;

export function getBaseUrl() {
  if (VITE_USER_NODE_ENV == 'production') {
    return 'https://guide-pro.youhangjh.com';
  } else {
    return 'https://guide-test.youhangjh.com';
  }
}
export function getBaseUrlInformation() {
  // if (VITE_USER_NODE_ENV == 'production') {
  //   return 'https://information-pro.usurong.com';
  // } else {
  //   return 'https://information-test.usurong.com';
  // }
  return window.location.origin;
}

export const baseImgUrlYsr = (url: string) => {
  let baseImgUrl = '';
  switch (VITE_USER_NODE_ENV) {
    case 'production':
      baseImgUrl = 'https://picture-pro.youhangjh.com/';
      break;
    case 'test':
      baseImgUrl = 'https://picture-test.youhangjh.com/';
      break;
    default:
      baseImgUrl = 'https://picture-test.youhangjh.com/';
  }
  if (url.indexOf('http') > -1 || url.indexOf('https') > -1) {
    return url;
  } else {
    return baseImgUrl + url;
  }
};
